(function () {
  function setText(scope, selector, value) {
    var el = scope.querySelector(selector);
    if (el) el.textContent = value || '';
  }

  function updatePrice(sectionId, data) {
    var root = document.querySelector('[data-bundle-price="' + sectionId + '"]');
    if (!root) return;
    var hasDeal = Boolean(data.old);
    setText(root, '[data-bundle-price-now]', data.price);
    setText(root, '[data-bundle-price-old]', data.old);
    setText(root, '[data-bundle-price-pct]', data.pct);
    setText(root, '[data-bundle-price-save]', data.save);
    setText(root, '[data-bundle-price-unit]', data.unit);
    root.querySelectorAll('[data-bundle-price-deal], [data-bundle-price-save-row]').forEach(function (el) {
      el.hidden = !hasDeal;
    });
  }

  function updateVolume(sectionId, volume) {
    document.querySelectorAll('[data-bundle-volume="' + sectionId + '"]').forEach(function (root) {
      var def = root.querySelector('[data-volume-default]');
      var override = root.querySelector('[data-volume-override]');
      if (!override) return;
      override.textContent = volume || '';
      override.hidden = !volume;
      if (def) def.hidden = Boolean(volume);
    });
  }

  function activate(root, radio) {
    var data = radio.dataset;
    root.querySelectorAll('.wt-bundle__tile').forEach(function (tile) {
      tile.classList.toggle('is-selected', tile.dataset.optionId === radio.value);
    });
    var qtyInput = root.querySelector('.wt-bundle__qty-input');
    if (qtyInput) qtyInput.value = data.cartQty;
    var giftCard = root.querySelector('[data-gift-card]');
    if (giftCard) giftCard.hidden = data.gift !== '1';
    updatePrice(root.dataset.bundleSection, data);
    updateVolume(root.dataset.bundleSection, data.volume);
  }

  function init(root) {
    if (root.dataset.bundleInit === '1') return;
    root.dataset.bundleInit = '1';
    root.querySelectorAll('.wt-bundle__tile input[type=radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) activate(root, radio);
      });
    });
    var checked = root.querySelector('.wt-bundle__tile input[type=radio]:checked');
    if (checked) activate(root, checked);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.wt-bundle').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
